// src/components/home/NutritionSection.jsx
import React from 'react';

// Nutrition card images
import card1 from '../../assets/A-card-img1.png';
import card2 from '../../assets/A-card-img2.png';
import card3 from '../../assets/A-card-img3.png';
import stemImage from '../../assets/stemImage3.png'

const NutritionSection = () => {
  const articles = [
    {
      date: "October 11, 2025",
      title: "Ayurvedic Morning Detox Routine",
      description:
        "Start your day with herbal infusions that cleanse and energize. Discover how turmeric, tulsi, and triphala can transform your mornings.",
      image: card1,
    },
    {
      date: "October 11, 2025",
      title: "Ancient Herbs for Stress Relief",
      description:
        "From ashwagandha to brahmi, explore how these adaptogenic herbs calm the mind and balance energy naturally.",
      image: card2,
    },
    {
      date: "October 11, 2025",
      title: "Balance Your Dosha for Better Health",
      description:
        "Understand the three doshas—Vata, Pitta, and Kapha—and learn how to maintain harmony through diet and lifestyle.",
      image: card3,
    },
  ];

  return (
    <section id="nutrition" className="bg-[#F1EAE1] py-[8rem] sm:py-20 md:py-24 px-4 sm:px-6 md:px-8 font-serif relative overflow-hidden">
      {/* Decorative stem */}
      
<img
  src={stemImage}
  alt="Decorative stem"
  className="absolute top-0 -right-10 w-16 sm:w-20 md:w-72 animate-float"
  style={{
    transform: 'rotate(0deg)',
    filter: 'brightness(1.05) saturate(1.2)',
  }}
/>
          {/* Top: Badge and Header */}
          <div className="nutrition-top text-center mb-12 sm:mb-16">
            <div className="nutrition-header inline-block text-center">
              <div className="nutrition-badge inline-block text-[#0B2A2C] px-4 sm:px-6 py-2 rounded-full text-xl font-medium mb-4 sm:mb-6 border border-[#0B2A2C]">
                 Nutrition
              </div>
              <h2 className="text-3xl sm:text-4xl md:text-[2.5rem] font-bold text-black-800 mb-3 sm:mb-4 leading-tight tracking-[-0.01em]">
                Discover Ayurvedic Wisdom
              </h2>
              <p className="text-base sm:text-lg text-black-700 leading-[1.5] font-light max-w-[90%] sm:max-w-[70%] mx-auto px-2">
                Explore time-tested remedies, lifestyle guides, and healing insights for mind, body, and soul.
              </p>
            </div>
          </div>
          {/* Cards Row - Flex with wrap, responsive min/max widths */}
          <div className="nutrition-cards flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 md:gap-8 max-w-6xl mx-auto flex-wrap">
            {/* Card 1 */}
            <div className="nutrition-card flex-1 min-w-full sm:min-w-[280px] md:min-w-[300px] max-w-[350px] rounded-xl overflow-hidden shadow-md relative transition-all duration-300 h-[350px] sm:h-[380px] md:h-[400px] hover:shadow-lg hover:-translate-y-1 mx-auto sm:mx-0">
              <div className="card-image w-full h-full relative">
                <img src={card1} alt="Ayurvedic doctor in morning setting" className="w-full h-full object-cover object-center" />
                <div className="card-date absolute top-1 right-4 sm:right-5 md:right-21 bg-green-50/90 text-green-800 px-2 sm:px-3 py-1 rounded-full text-xs font-medium z-10 border border-black-800">
                    October 11, 2025
                  </div>
                <div className="card-overlay absolute bottom-4 sm:bottom-6 left-1/2 -translate-x-1/2 w-[90%] sm:w-[85%] bg-[#F1EAE1] p-4 sm:p-6 rounded-xl shadow-lg backdrop-blur-sm border border-amber-700/20 h-[35%] sm:h-[40%]">
                 
                  <div className="card-content mt-0 px-1 sm:px-2 pb-2">
                    <h3 className="text-base sm:text-lg text-black-800 mb-2 font-bold leading-tight">
                      Ayurvedic Morning Detox Routine
                    </h3>
                    <p className="text-xs text-black leading-[1.4] font-light mb-0">
                      Start your day with herbal infusions that cleanse and energize. Discover how turmeric, tulsi, and triphala can transform your mornings.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Card 2 */}
            <div className="nutrition-card flex-1 min-w-full sm:min-w-[280px] md:min-w-[300px] max-w-[350px] rounded-xl overflow-hidden shadow-md relative transition-all duration-300 h-[350px] sm:h-[380px] md:h-[400px] hover:shadow-lg hover:-translate-y-1 mx-auto sm:mx-0">
              <div className="card-image w-full h-full relative">
                <img src={card2} alt="Bottle of ancient herbs" className="w-full h-full object-cover object-center" />
                <div className="card-date absolute top-1 right-4 sm:right-5 md:right-21 bg-green-50/90 text-green-800 px-2 sm:px-3 py-1 rounded-full text-xs font-medium z-10 border border-black-800">
                    October 11, 2025
                  </div>
                <div className="card-overlay absolute bottom-4 sm:bottom-6 left-1/2 -translate-x-1/2 w-[90%] sm:w-[85%] bg-[#F1EAE1] p-4 sm:p-6 rounded-xl shadow-lg backdrop-blur-sm border border-amber-700/20 h-[35%] sm:h-[40%]">
                 
                  <div className="card-content mt-0 px-1 sm:px-2 pb-2">
                    <h3 className="text-base sm:text-lg text-black-800 mb-2 font-bold leading-tight">
                      Ancient Herbs for Stress Relief
                    </h3>
                    <p className="text-xs text-black leading-[1.4] font-light mb-0">
                      From ashwagandha to brahmi, explore how these adaptogenic herbs calm the mind and balance energy naturally.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Card 3 */}
            <div className="nutrition-card flex-1 min-w-full sm:min-w-[280px] md:min-w-[300px] max-w-[350px] rounded-xl overflow-hidden shadow-md relative transition-all duration-300 h-[350px] sm:h-[380px] md:h-[400px] hover:shadow-lg hover:-translate-y-1 mx-auto sm:mx-0">
              <div className="card-image w-full h-full relative">
                <img src={card3} alt="Cup of herbal tea" className="w-full h-full object-cover object-center" />
                <div className="card-date absolute top-1 right-4 sm:right-5 md:right-21 bg-green-50/90 text-green-800 px-2 sm:px-3 py-1 rounded-full text-xs font-medium z-10 border border-black-800">
                    October 11, 2025
                  </div>
                <div className="card-overlay absolute bottom-4 sm:bottom-6 left-1/2 -translate-x-1/2 w-[90%] sm:w-[85%] bg-[#F1EAE1] p-4 sm:p-6 rounded-xl shadow-lg backdrop-blur-sm border border-amber-700/20 h-[35%] sm:h-[40%]">
                 
                  <div className="card-content mt-0 px-1 sm:px-2 pb-2">
                    <h3 className="text-base sm:text-lg text-black-800 mb-2 font-bold leading-tight">
                      Balance Your Dosha for Better Health
                    </h3>
                    <p className="text-xs text-black leading-[1.4] font-light mb-0">
                      Understand the three doshas—Vata, Pitta, and Kapha—and learn how to maintain harmony through diet and lifestyle.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
  );
};

export default NutritionSection;